import React, { type FC } from 'react';
import { CheckCircleFilled, EditFilled, MailFilled, MessageFilled, MobileFilled } from '@ant-design/icons';
import { presetPalettes } from '@ant-design/colors';
import { Space, Text } from '@g2u/ui-kit';
import { Spin } from 'antd';

import { type WithOptionalDataTest } from 'types';
import styles from '../callbacks.module.scss';

export namespace CloseCallbackSteps {
  export type Props = {
    step?: number;
  } & WithOptionalDataTest;

  export const $: FC<Props> = (props) => {
    const { step } = props;
    if (step === undefined || isNaN(step)) return <Spin />;

    const commentStep = step === 0;
    const voiceMessageStep = step > 0;
    const emailStep = step > 1;
    const smsStep = step > 2;

    return (
      <Space.$ direction={Space.Direction.Vertical} size={Space.Size.Middle}>
        {commentStep && (
          <div className={styles.callbacks__modalStepTitle}>
            <EditFilled style={{ color: presetPalettes.blue[5] }} /> <Text.$>Add a Callback Note</Text.$>
          </div>
        )}
        {voiceMessageStep && (
          <div className={styles.callbacks__modalStepTitle}>
            <MessageFilled style={{ color: presetPalettes.blue[5] }} /> <Text.$>Leave a voice message</Text.$>
            {emailStep && <CheckCircleFilled className={styles.callbacks__modalStepTitleStatus} />}
          </div>
        )}
        {emailStep && (
          <div className={styles.callbacks__modalStepTitle}>
            <MailFilled style={{ color: presetPalettes.blue[5] }} /> <Text.$>Send an Email</Text.$>
            {step > 2 && <CheckCircleFilled className={styles.callbacks__modalStepTitleStatus} />}
          </div>
        )}
        {smsStep && (
          <div className={styles.callbacks__modalStepTitle}>
            <MobileFilled style={{ color: presetPalettes.blue[5] }} /> <Text.$>Send an SMS</Text.$>
          </div>
        )}
      </Space.$>
    );
  };
}
